import React from 'react'
import RecordSection from './_RecordSection'
import { Text, View } from '@react-pdf/renderer'
import MedicalDrawing from './MedicalDrawing'

const Attachments = ({ epcr, anonymised }) => {
  if ((epcr?.attachments ?? []).length === 0) {
    return null
  } else {
    return (
      <RecordSection title="Attachments">
        <View
          style={{
            width: '100%',
            gap: 5,
            fontSize: 10,
            paddingHorizontal: 5,
            paddingVertical: 2,
          }}
        >
          {anonymised ? (
            <Text>Attachments are not included in anonymised records.</Text>
          ) : (
            <View
              style={{ flexDirection: 'row', flexWrap: 'wrap', width: '100%' }}
            >
              {epcr.attachments.map((x) => (
                <View
                  key={x._id}
                  rowGap={1}
                  style={{
                    width: '50%',
                    padding: 6,
                    boxSizing: 'border-box',
                  }}
                >
                  <MedicalDrawing
                    imageKey={x.s3key}
                    src={x.url}
                    style={{
                      width: '100%',
                      height: 200,
                      objectFit: 'contain',
                    }}
                  />
                </View>
              ))}
            </View>
          )}
        </View>
      </RecordSection>
    )
  }
}

export default Attachments
